<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-09-30 09:44:08
 * @Description: 成本结转表-生成审批单
 * @FilePath: \PCMS-Share\src\views\ShareSystem\components\report\approvalForm.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1140px" :close-on-click-modal="false" :before-close="resetForm">
      <span slot="title" class="dialog-title">生成业务记账单</span>
      <div>
        <el-form ref="form" :rules="rules" :model="formVal" label-width="150px" :inline="true" label-position="right">
          <el-form-item label-width="80px" prop="submitUserName">
            <span slot="label">申请人</span>
            <span v-if="!formVal.submitUserName" style="color: forestgreen;width: 250px;"
              @click="openAccount">请选择申请人</span>
            <span v-else style="color: forestgreen;" @click="openAccount">
              <el-input v-model="formVal.submitUserName" style="color: forestgreen;width: 250px;"></el-input>
            </span>
          </el-form-item>
          <div>
            <el-form-item label-width="80px" prop="sharedProductName">
              <span slot="label">项目</span>
              <span v-if="!formVal.sharedProductName" style="color: forestgreen;width: 250px;"
                @click="openProject">请选择项目</span>
              <span v-else style="color: forestgreen;" @click="openProject">
                <el-input v-model="formVal.sharedProductName" style="color: forestgreen;width: 250px;"></el-input>
              </span>
            </el-form-item>
            <el-form-item prop="paperAttachments">
              <span slot="label">纸质附件</span>
              <el-select ref="selection" v-model="formVal.paperAttachments" style="width: 200px">
                <el-option :key="0" label="无" :value="0"></el-option>
                <el-option :key="1" label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe show-overflow-tooltip style="width: 100%"
          :data="tableData" tooltip-effect="dark" :span-method="objectSpanMethod">
          <template v-for="(item, index) in table">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
              align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '业务大类'">
                  <el-select v-model="tableData[0].businessType" placeholder="请选择" filterable clearable
                    style="width:100%">
                    <el-option v-for="item in businessBigTypeList" :key="item.operationTypeCode"
                      :label="item.operationTypeName" :value="item.operationTypeName"
                      @click.native="setSmallName(item, 0)"></el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '业务类型'">
                  <el-select v-model="scope.row.businessSmallType" placeholder="请选择" filterable clearable
                    style="width:100%">
                    <el-option v-for="item in businessTypeList[0]" :key="item.operationSubTypeCode"
                      :label="item.operationSubTypeName" :value="item.operationSubTypeName"
                      @click.native="setBusinessName(item, scope.$index)"></el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '费用分摊部门'">
                  <el-link v-if="!scope.row.costShareDepartment" :underline="false" type="success"
                    @click="openDepDetail(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openDepDetail(scope.$index)">{{
                    scope.row.costShareDepartment }}</el-link>
                </span>
                <span v-else-if="item.label == '明细供应商'">
                  <el-link v-if="!scope.row.detailSupply" :underline="false" type="success"
                    @click="openSupplyDetail(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openSupplyDetail(scope.$index)">{{
                    scope.row.detailSupply }}</el-link>
                </span>
                <span v-else-if="item.label == '事由'">
                  <el-input v-model="tableData[0].resion" style="width:100%" placeholder="请输入事由"></el-input>
                </span>
                <span v-else-if="item.label == '分摊金额'">
                  <el-input v-model="scope.row.money" type="number" style="width:100%" placeholder="请输入"></el-input>
                </span>
                <span v-else-if="item.label == '附件'">
                  <el-button class="bottom_one" size="mini" @click="upFile(0)">上传</el-button>
                </span>
                <span v-else-if="item.label == '操作'">
                  <el-button size="mini" type="success" icon="el-icon-plus" circle
                    @click="addItem(scope.$index)"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-minus" circle
                    @click="delItem(scope.$index)"></el-button>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetForm">关 闭</el-button>
        <el-button class="bottom_all" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 上传附件 -->
    <el-dialog v-dialogDrag :visible.sync="uploadFileDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">上传附件</span>
      <div v-loading="loading" element-loading-text="上传中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag
          action="/resource/resources/upload" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
          <div slot="tip" class="el-upload__tip" style="color:red">*{{ upload_tip }}</div>
        </el-upload>
        <div style="margin:10px;font-size:18px">
          <div style="text-align: left;">
            已上传文件:
            <div v-for="(item, index) in tableData[0].files" :key="index">
              <el-link type="sucess" :underline="false" @click="lookFile(item.url)">{{
                item.name }}</el-link> <el-link v-if="index != 0" type="danger" style="margin-left: 24px;"
                :underline="false" @click="deleteFile(index)">删除</el-link>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="uploadFileDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 核算主体 -->
    <AccountTable ref="accountTable" :dialog.sync="accountDialog" @resetAccount="resetAccount" @setAccount="setAccount" />
    <!-- 项目 -->
    <ProjectTable ref="projectTable" :dialog.sync="projectDia" @resetProject="resetProject" @setProject="setProject" />
    <!-- 费用分摊部门 -->
    <DepTable ref="DepTable" :dialog.sync="depDia" @resetDep="resetDep" @setDep="setDep" />
    <!-- 明细客商 -->
    <detailSupply ref="detailSupply" :dialog.sync="detailSupplyDialog" :detailRow="detailRow" :saveType="saveType"
      @reset="resetSupply" @setDetail="setDetail" />
  </div>
</template>
<script>
import { cardLogin_HX, getUserList_HX, getProject_HX, updateGXCostState } from "@/views/ShareSystem/api/mainHx.js";
import AccountTable from "./accountTable.vue";
import ProjectTable from "./ProjectTable.vue";
import DepTable from "./DepTable.vue";
import detailSupply from "@/views/ShareSystem/components/contract/detailSupply";
import { generateBusinessAccessory } from "@/api/docking.js";
import { UPLOAD_TIP } from "@/utils/utils";
import { getToken } from "@/utils/auth";
import { saveBusinessAccessory } from "@/api/docking.js";
import {
  getCategory
} from "@/views/ShareSystem/api/mainHx.js";
import { _debounce } from '@/utils/utils.js'
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
  components: {
    AccountTable,
    ProjectTable,
    DepTable,
    detailSupply
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    params: {},
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
        status: 1,//只查询启用状态
      },
      accessToken: "",
      total: 0,
      // userData: [],
      projectHxList: [],
      businessBigList: [
        { id: "HSYW227", name: "库存商品出库" },
      ],
      businessSmallList: [
        { id: "HSYW227001", name: "自制库存商品-结转主营业务成本" },
        { id: "HSYW227002", name: "外购库存商品结转主营业务成本" },
      ],
      rules: {
        submitUserName: [{ required: true, message: "请选择事由", trigger: "change" }],
        sharedProductName: [{ required: true, message: "请选择事由", trigger: "change" }],
        paperAttachments: [{ required: true, message: "请选择事由", trigger: "change" }],
      },
      accountDialog: false, //核算主体
      projectDia: false,//项目
      depDia: false,//分摊部门
      formVal: {
        // accountMainBody:"",
        mainBodyId: "",
        mainBodyName: "",
        businessTime: "",
        paperAttachments: 0,
        submitUserName: "",
        sharedProductCode: "",
        sharedProductName: "",
      },
      detailSupplyDialog: false,//明细客商
      detailRow: {},
      saveType: "2",
      tableData: [
        {
          files: [],
        },
        {
          files: [],
        },
        {
          files: [],
        }
      ],
      oldAmount: 0,
      table: [
        { label: "业务大类", width: "150px", prop: "operationSubTypeName", status: true },
        { label: "业务类型", width: "150px", prop: "operationSubTypeName", status: true },
        { label: "费用分摊部门", width: "150px", prop: "costShareDepartment", status: true },
        { label: "明细供应商", width: "150px", prop: "detailSupply", status: true },
        { label: "分摊金额", width: "auto", prop: "money", status: true },
        { label: "事由", width: "150", prop: "operationSubTypeName", status: true },
        { label: "附件", width: "80", prop: "operationSubTypeName", status: true },
        { label: "操作", width: "100", prop: "", status: true },
      ],
      businessTypeList: [[], [], []],
      lowindex: 0,
      fileArr: [],
      uploadFileDig: false,
      upload_tip: UPLOAD_TIP,
      upheader: {},
      loading: false,
      businessBigTypeList: [],
    }
  },
  watch: {
  },
  created() {
    this.upheader = {
      "access-token": getToken(),
    };
  },
  methods: {
    delItem(index) {
      if (this.tableData.length > 1) {
        this.tableData.splice(index, 1);
      }
    },
    addItem(index) {
      let obj = {
        businessSmallType: '',
        operationSubTypeId: '',
        // businessSmallType: this.tableData[0].businessSmallType,
        // operationSubTypeId: this.tableData[0].operationSubTypeId,
        businessType: this.tableData[0].businessType,
        operationTypeCode: this.tableData[0].operationTypeCode,
        code: this.tableData[0].code,
        mainBodyId: this.tableData[0].mainBodyId,
        mainBodyName: this.tableData[0].mainBodyName,
        resion: this.tableData[0].resion,
        files: this.tableData[0].files,
        detailSupply: "",
        venderCode: "",
        costShareDepartment: "",
        expenseDeptId: "",
      }
      this.tableData.splice(index + 1, 0, obj);
    },
    deleteFile(index) {
      this.tableData[0].files.splice(index, 1);
    },
    lookFile(imgUrl) {
      window.open(imgUrl, "_blank");
    },
    filebefore(file) {
      this.loading = true;
      const allowedFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("数据上传必须是  pdf, jpeg, jpg, png,格式!");
        this.loading = false;
      }
      return isAllowedFormat;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code === 1001) {
        this.tableData[0].files.push({
          name: res.data.fileName,
          url: 'https://lvshe.huashijc.com/file/' + res.data.fileUrl
        })
      }
    },
    upFile(index) {
      console.log(this.tableData)
      this.lowindex = index
      this.uploadFileDig = true
    },
    changeFileName() {
      this.tableData.forEach(item => {
        item.files[0].name = item.businessSmallType
      })
    },
    async initData() {
      console.log("this.params----------------------------------")
      console.log(this.params)
      this.formVal.mainBodyId = this.params.companyId
      this.formVal.mainBodyName = this.params.mianBody
      this.formVal.businessTime = this.params.accountPeriod
      this.formVal.dataType = 2
      let that = this
      let res = await cardLogin_HX({ idCard: "icps" })
      if (res.code == 1001) {
        let info = res.data;
        if (info && info.accessToken) {
          that.accessToken = info.accessToken
          // this.getUserList(that.accessToken);
          // this.getProject_HX(that.accessToken);
          this.generateBusinessAccessory(that.params);
          this.getCategory();
        }
      }
    },
    restParams() {
      this.tableParams = {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      }
      this.initData();
    },
    resetSupply() {
      this.detailSupplyDialog = false
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // let num = 0
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          const values = data.map(item => Number(item["totalAmount"]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = '';
          }
        }
        if (index === 3) {
          sums[index] = this.oldAmount;
          return;
        }
      });
      return sums;
    },
    setBusinessName(data, index) {
      this.tableData[index].operationSubTypeId = data.operationSubTypeCode
    },
    setName(data) {
      this.formVal.employeeCode = data.code
      this.$refs.accountTable.setNcNo(data);
    },
    setSmallName(data, index) {
      this.tableData[index].operationTypeCode = data.id
      this.getCategory(data.operationTypeName, index)
    },
    setDetail(param) {
      console.log(param)
      this.tableData[this.lowindex].detailSupply = param.profitCsName
      this.tableData[this.lowindex].venderCode = param.profitCsCode
      this.resetSupply();
    },
    setAccount(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.submitUserName = row.deptName
      this.formVal.deptName = row.deptName
      this.formVal.leCode = row.deptCode
      this.formVal.employeeCode = row.foreignId
      this.formVal.postId = row.positionCode
    },
    setProject(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.sharedProductCode = row.code
      this.formVal.sharedProductName = row.name
    },
    setDep(param) {
      console.log(param)
      this.tableData[this.lowindex].costShareDepartment = param.name
      this.tableData[this.lowindex].expenseDeptId = param.code
      this.resetDep();
    },
    openSupplyDetail(index) {
      this.lowindex = index
      this.detailSupplyDialog = true
      this.$refs.detailSupply.initData();
    },
    openDepDetail(index) {
      this.lowindex = index
      this.depDia = true
    },
    getProject_HX(accessToken) {
      if (!accessToken) {
        this.$message.error('accessToken获取为空～')
        return;
      } else {
        getProject_HX({ page: 1, pageSize: 100 }, accessToken).then((res) => {
          this.projectHxList = res.data?.data;
        });
      }
    },
    getUserList(accessToken) {
      getUserList_HX(accessToken).then((res) => {
        this.userData = res.data;
        console.log(this.userData)
      });
    },
    getCategory(operationTypeName, index) {
      let param = {
        page: 1,
        pageSize: 9999,
        operationTypeName: operationTypeName,
      }
      getCategory(param, this.accessToken).then(res => {
        if (res.code == 1001) {
          if (index || index == 0) {
            this.$set(this.businessTypeList, index, res.data.records[0].mainDictGxBusinessList);
          } else {
            this.businessBigTypeList = res.data.records;
          }

        }
      });
    },

    generateBusinessAccessory(data) {
      console.log(data)
      let params = {
        businessTime: data.accountPeriod,
        mainBodyId: data.companyId,
      }
      this.oldAmount = 0
      generateBusinessAccessory(params).then((res) => {
        if (res.code == 1001) {
          if (res.data.length == 0) {
            this.$emit("mainLoadingClose");
          } else {
            this.$emit('openDialog')
            if (res?.data?.length > 0) {
              res.data.forEach((item, index) => {

                //设置默认值
                if (index == 0) {
                  item['files'] = [{ name: '原材料出库', url: data.file }]
                  item.businessType = '原材料出库'
                  item.operationTypeCode = 'HSYW142'
                  item.businessSmallType = '生产车间机械费使用'
                  item['operationSubTypeId'] = 'HSYW142016'
                  // item.resion = this.formVal.businessTime + '原材料耗用' //事由默认值
                }
                if (index == 1) {
                  item['files'] = [{ name: '原材料耗用', url: data.file }]
                  item.businessType = '原材料出库'
                  item.operationTypeCode = 'HSYW142'
                  item.businessSmallType = '制造费用_修理费_自行修理'
                  item['operationSubTypeId'] = 'HSYW142054'
                  // item.resion = this.formVal.businessTime + '原材料耗用' //事由默认值
                }
                //获取业务类型
                this.getCategory(item.businessType, index)
                //建材主体
                if (data.companyId == '22876753760489472') {
                  // if (index == 0) {
                  //   item.detailSupply = '外部单位'
                  //   item.venderCode = 'HS061084531'
                  // }
                  // else {
                  //   item.detailSupply = '四川华西绿舍混凝土工程有限公司本部'
                  // item.venderCode = 'HG0212'
                  // }
                  item.detailSupply = '外部单位'
                  item.venderCode = 'HS061084531'
                  item.costShareDepartment = '跳蹬河搅拌站'
                  item.expenseDeptId = 'HB0202012'
                  this.formVal.sharedProductCode = 'HG0202-20220831001'
                  this.formVal.sharedProductName = '四川华西绿舍建材有限公司混凝土事业部分部'
                } else if (data.companyId == '112740030409216000') { //混凝土工程有限公司
                  // if (index == 0) {
                  //   item.detailSupply = '外部单位'
                  //   item.venderCode = 'HS061084531'
                  // }else {
                  //   item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
                  //   item.venderCode = 'HG0202'
                  // }
                  item.detailSupply = '外部单位'
                  item.venderCode = 'HS061084531'
                  item.costShareDepartment = '崇州搅拌站'
                  item.expenseDeptId = 'HB0212001'
                  this.formVal.sharedProductCode = 'HG0212-20220831001'
                  this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司本部'
                } else if (data.companyId == '360866214131666944') { //金牛
                  // if (index == 0) {
                  //   item.detailSupply = '外部单位'
                  //   item.venderCode = 'HS061084531'
                  // }else {
                  //   item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
                  //   item.venderCode = 'HG0202'
                  // }
                  item.detailSupply = '外部单位'
                  item.venderCode = 'HS061084531'
                  item.costShareDepartment = '安全营运部'
                  item.expenseDeptId = 'HB021202003'
                  this.formVal.sharedProductCode = 'HG02120201-20231130001'
                  this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司金牛分公司分部'
                } else if (data.companyId == '361334596329148416') { //青白江
                  // if (index == 0) {
                  //   item.detailSupply = '外部单位'
                  //   item.venderCode = 'HS061084531'
                  // }else {
                  //   item.detailSupply = ''
                  // item.venderCode = ''
                  // }
                  item.detailSupply = '外部单位'
                  item.venderCode = 'HS061084531'
                  item.costShareDepartment = '崇州搅拌站'
                  item.expenseDeptId = 'HB0202018'
                } else if (data.companyId == '361334653501706240') { //武侯
                  // if (index == 0) {
                  //   item.detailSupply = '外部单位'
                  //   item.venderCode = 'HS061084531'
                  // }else {
                  //   item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
                  //   item.venderCode = 'HG0202'
                  // }
                  item.detailSupply = '外部单位'
                  item.venderCode = 'HS061084531'
                  item.costShareDepartment = '安全营运部'
                  item.expenseDeptId = 'HB021201003'
                  this.formVal.sharedProductCode = 'HG02120101-20231130001'
                  this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司武侯分公司分部'
                }


                else {
                  item.detailSupply = ''
                  item.costShareDepartment = ''
                }
              })
              this.$set(this, 'tableData', res.data)
            }
          }

        } else {
          this.$emit("mainLoadingClose");
        }
      }).catch(() => {
        this.$emit("mainLoadingClose");
      });
    },
    openAccount() {
      this.accountDialog = true
      this.$refs.accountTable.initData();
    },
    resetAccount() {
      this.accountDialog = false
    },
    openProject() {
      this.projectDia = true
    },
    resetProject() {
      this.projectDia = false
    },
    resetDep() {
      this.depDia = false
    },

    resetForm() {
      this.formVal = this.$options.data().formVal
      this.$emit("resetForm");
    },
    //月报量-保存
    submitForm: _debounce(function () {
      if (!this.formVal.submitUserName) {
        this.$message.warning('请选择申请人!')
        return
      }
      if (!this.formVal.sharedProductName) {
        this.$message.warning('请选择项目!')
        return
      }
      if (!this.formVal.paperAttachments && this.formVal.paperAttachments != 0) {
        this.$message.warning('请选择纸质附件!')
        return
      }
      let tableData = JSON.parse(JSON.stringify(this.tableData))
      console.log(tableData)
      let tableDataMust = false
      const detailedinfomationarea = []
      tableData.forEach((item, index) => {
        if (index > 0) {
          // item.businessSmallType = this.tableData[0].businessSmallType
          // item.operationSubTypeId = this.tableData[0].operationSubTypeId
          item.businessType = this.tableData[0].businessType
          item.operationTypeCode = this.tableData[0].operationTypeCode
          item.resion = this.tableData[0].resion
          item.files = this.tableData[0].files
        }
        if ((!item.operationTypeCode || !item.operationSubTypeId || !item.expenseDeptId || !item.venderCode || !item.resion || !item.money) && item.money!=0) {
          tableDataMust = true
        }
        item.order = {
          icpsDataUrl: `https://lvshe.huashijc.com/#/accessoryMaterialDetail_HX?code=${item.code}`,
          boeAbstract: item.resion,//事由
          postId: this.formVal.postId,//岗位
          project: this.formVal.sharedProductCode,//项目编码
          leCode: this.formVal.leCode,//核算主体
          employeeCode: this.formVal.employeeCode,//申请人
          operationTypeCode: item.operationTypeCode,//业务大类
          paperAccessories: this.formVal.paperAttachments, // 纸质附件是或否Y/N
          detailedinfomationarea: [],
          zfsAttachment: item.files
        }
        detailedinfomationarea.push({
              amount: item.money,//金额
              customer: "",//客商
              resarchProject: "",//研发课题
              operationSubTypeId: item.operationSubTypeId,//
              venderCode: item.venderCode,//供应商
              expenseDeptId: item.expenseDeptId,// 费用分摊部门
            })
        item.attachment = JSON.stringify(item.files)
        item.mainBodyName = this.formVal.mainBodyName
        item.mainBodyId = this.formVal.mainBodyId
        item.sharedProductCode = this.formVal.sharedProductCode
        item.sharedProductName = this.formVal.sharedProductName

      })
      if (tableDataMust) {
        this.$message.warning('请检查表格数据是否为空！')
        return
      }
      tableData.forEach(item => {
        item.order.detailedinfomationarea = detailedinfomationarea
      })
      console.log(tableData)
      //分摊金额为0的不推送
      this.formVal['detailList'] = tableData.filter(item =>item.money != 0)
      // console.log(this.formVal)
      saveBusinessAccessory(this.formVal).then((res) => {
        if (res.code == 1001) {
          this.$message.success(res.codeMsg)
          this.resetForm();
          this.$router.push({ name: 'accountingSheet', query: { mainBodyId: this.formVal.mainBodyId, businessTime: this.formVal.businessTime,dataType:2 } })
        }
      });
    }, 500),
    updateGXCostState() {
      let param = {
        endTime: this.params.endTime,
        startTime: this.params.startTime,
        lisiTime: this.params.lisiTime,
        settleMonth: this.params.settleMonth,
        companyId: this.params.secondId,
        checkStatus: 0,
        gxStatus: 0
      }
      updateGXCostState(param).then(res => {
        if (res.code == 1001) {
          let dataContent = {
            params: param,
            settlementStartTime: param.startTime,
            settlementEndTime: param.endTime,
            periodSettlement: [param.startTime, param.endTime]
          }
          const query = {
            type: 1,
            taskName: "业务记账单审批表",
            taskStatus: 0,
            taskType: 1,
            dataContent: JSON.stringify(dataContent)
          };
          this.$router.push({ name: 'submitBusinessBilling', query: query })
        }
      }).catch(() => {
        // this.$message.warning(r) 
      })
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.initData();
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 需要合并的列索引：第一列(0)、第二列(1)、第五列(4)
      const mergeCols = [0, 5, 6];

      if (mergeCols.includes(columnIndex)) {
        if (rowIndex === 0) {
          // 第一行显示，跨所有行
          return { rowspan: this.tableData.length, colspan: 1 };
        } else {
          // 其他行隐藏单元格
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 其他列正常显示
      return { rowspan: 1, colspan: 1 };
    }
  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}</style>